export const publicNavLinks = [
  { hash: "#platform", key: "public_nav_platform" },
  { hash: "#ai-engines", key: "public_nav_ai" },
  { hash: "#districts", key: "public_nav_districts" },
  { hash: "#trust", key: "public_nav_trust" },
]
